function initWindowFocusHandler() {
  window._isFocused = true;
  window.addEventListener('focus', () => {
    window._isFocused = true;
  });

  window.addEventListener('blur', () => {
    window._isFocused = false;
  });
}

initWindowFocusHandler();
